import { Stack } from "@fluentui/react/lib/Stack";
import { Link } from "@fluentui/react/lib/Link";

import { RelevanceActionButton } from "Components/Details/RelevanceActionButton";
import { isNullOrWhiteSpace } from "Utils/String";
import { IconButtonWithTooltip } from "Components/Generic/IconButtonWithTooltip";
import { WithTranslator } from "Components/Generic/Translator";
import { useCompanyActionsStyles } from "./UseCompanyActionsStyles";
import { CompanyRole } from "./CompanyRole/CompanyRole";
import { ICompanyActionsProps } from "./ICompanyActionsProps";

export const CompanyActions = WithTranslator((props: ICompanyActionsProps): JSX.Element => {
  const { company, translator } = props;
  const styles = useCompanyActionsStyles();
  const targetUrl = company[`@targetUrl`];

  const isExternalLinkDisabled = company[`@isExported`] !== true || isNullOrWhiteSpace(targetUrl);
  return (
    <>
      <Stack.Item grow={false} disableShrink={false}>
        <Link as="a" href={targetUrl} target="_blank" disabled={isNullOrWhiteSpace(targetUrl)}>
          <IconButtonWithTooltip
            className={styles.open}
            iconProps={{ iconName: `NavigateExternalInline` }}
            tooltip={translator.get(`tooltip.openexternal`, `Opens the exported record in an external window.`)}
            disabled={isExternalLinkDisabled}
          />
        </Link>
      </Stack.Item>
      <Stack.Item grow={false} disableShrink={false}>
        <RelevanceActionButton item={company} />
      </Stack.Item>
      <Stack.Item grow={false} className={styles.roles}>
        <CompanyRole company={company} />
      </Stack.Item>
    </>
  );
});
